module.exports = __webpack_public_path__ + "1b0a5f68ad9a211a301ce1476f5cb93f.svg";